<template>
  <div>
    <b-tr v-for="product in topologyItem.Products" :key="product.ProductId">
      <b-form-checkbox class="ml-3" :style="'padding-left:' + paddingLeft + 'rem'" v-model="product.Download" @change="setDownload(product, product.Download)">
        <h6>
          {{ product.DisplayName }}
          <span class="smaller float-md-right mx-2"><b-badge style="font-size: 10px">Product</b-badge></span>
        </h6>
      </b-form-checkbox>
      <sections
        :topologyItem="product" :paddingLeft="paddingLeft + 2" @checkParent="checkParent" />
    </b-tr>
  </div>
</template>
<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator'
import Sections from './sections.vue'

@Component({
  components: {
    'sections': Sections,
  },
})

export default class extends Mixins() {
  @Prop()
  public topologyItem!: any

  @Prop()
  public paddingLeft!: number

  public checkParent() {
    this.topologyItem.Download = true
    this.$emit('checkParent')
  }

  public setDownload(item: any, value: boolean) {
    if (value) {
      this.checkParent()
    }
    if (item.Sections) {
      item.Sections.forEach((s) => {
        s.Download = value
        s.Tabs?.forEach((t) => {
          t.Download = value
          t.Tables?.forEach((ta) => {
            ta.Download = value
            ta.Models?.forEach((m) => {
              m.Download = value
            })
          })
        })
      })
    }
  }
}
</script>
